import { useState } from 'react';

import Image from 'next/image';

import {
  getAnswer,
  getReviewDate,
  getReviewImageUrl,
  getUserName
} from '@screens/Product/ui/MiddleTabs/Reviews/utils/formatters';
import { ProductReviewType } from '@shared/types/product';
import { HStack } from '@shared/ui/Stack';
import { LightBoxModal } from '@widgets/LightBoxModal';

import { Stars } from './ReviewStars';
import cls from './Reviews.module.scss';

type ReviewItemProps = {
  review: ProductReviewType;
};

export const ReviewItem = ({ review }: ReviewItemProps) => {
  const [currentImageUrl, setCurrentImageUrl] = useState('');
  const { id, user, rating, comment, createdAt, reviewImages, reviewAnswers } = review;
  const images = reviewImages.map(getReviewImageUrl).filter((image): image is string => Boolean(image));
  const answerData = getAnswer(reviewAnswers?.[0]);

  const handleCloseLightBox = () => {
    setCurrentImageUrl('');
  };

  const handleOpenLightBox = (url: string) => () => {
    setCurrentImageUrl(url);
  };

  return (
    <>
      <article
        key={id}
        className={cls.review}
      >
        <HStack
          max
          className={cls.reviewHead}
        >
          <HStack className={cls.user}>
            <div className={cls.avatar} />
            <div className={cls.name}>{getUserName(user)}</div>
          </HStack>

          <HStack className={cls.meta}>
            <div className={cls.date}>{getReviewDate(createdAt)}</div>
            <Stars
              rate={rating}
              className={cls.reviewStars}
            />
          </HStack>
        </HStack>

        <p className={cls.reviewText}>{comment}</p>

        {images.length > 0 && (
          <div className={cls.images}>
            {images.map((src, index) => (
              <button
                key={`${src}-${index}`}
                type="button"
                className={cls.imageButton}
                onClick={handleOpenLightBox(src)}
                aria-label="Открыть фотографию отзыва"
              >
                <Image
                  src={src}
                  width={216}
                  height={105}
                  alt={''}
                  className={cls.image}
                />
              </button>
            ))}
          </div>
        )}

        {answerData && (
          <div className={cls.answer}>
            <HStack className={cls.answerHead}>
              <div className={cls.answerAvatar}>OLEVARO</div>
              <div className={cls.answerName}>
                {answerData.name}
                <span className={cls.verified} />
              </div>
            </HStack>
            <HStack className={cls.answerContent}>
              <p>{answerData.text}</p>
              {answerData.date && <span>{answerData.date}</span>}
            </HStack>
          </div>
        )}
      </article>

      {currentImageUrl && (
        <LightBoxModal
          open={Boolean(currentImageUrl)}
          imageUrls={images}
          currentImageUrl={currentImageUrl}
          onClose={handleCloseLightBox}
        />
      )}
    </>
  );
};
